module.exports = __webpack_public_path__ + "static/img/齿直角方式变位斜齿齿轮的计算.9e26dbe3.jpg";